import { create } from "zustand";

interface LayoutStoreType {
  isSubTab: boolean;
  isHeader: boolean;
  setLayout: (layout: LayoutForm) => void;
}

interface LayoutForm {
  isSubTab: boolean;
  isHeader: boolean;
}

const useLayoutStore = create<LayoutStoreType>((set) => ({
  isSubTab: false,
  isHeader: false,
  setLayout: (layout: LayoutForm) => {
    set((state) => ({
      ...state,
      isSubTab: layout.isSubTab,
      isHeader: layout.isHeader,
    }));
  },
}));

export default useLayoutStore;
